import { Navbar } from "@web/components/Navbar";
import { UnAuthedMessage } from "@web/components/UnAuthedMessage";

interface Props {
  actionMessage?: string;
}

export function UnAuthedPage({ actionMessage }: Props) {
  return (
    <>
      <UnAuthedMessage actionMessage={actionMessage} />
      <Navbar />
    </>
  );
}
